export const CREATE_CUSTOMERS_COMMENT_REQUEST = 'CREATE_CUSTOMERS_COMMENT_REQUEST';
export const CREATE_CUSTOMERS_COMMENT_SUCCESS = 'CREATE_CUSTOMERS_COMMENT_SUCCESS';
export const CREATE_CUSTOMERS_COMMENT_FAILURE = 'CREATE_CUSTOMERS_COMMENT_FAILURE';
